import * as types from "../../ActionType";

const initState = {
    zone: [],
    loadingZone: true,
    zoneWarehouse: [],
    loadingZoneWarehouse: true
}

const ZoneReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_ZONE:
            return { ...state, loadingZoneWarehouse: true }
        case types.LOAD_ZONE_WAREHOUSE:
            return { ...state, loadingZoneWarehouse: false }
        case types.GET_ZONES:
            return { ...state, zone: action.payload, loadingZone: false }
        case types.GET_ZONES_BY_WAREHOUSE:
            return { ...state, zoneWarehouse: action.payload, loadingZoneWarehouse: false }
        case types.EMPTY_ZONES_BY_WAREHOUSE:
            return { ...state, zoneWarehouse: action.payload, loadingZoneWarehouse: true }
        case types.DELETE_ZONE:
            return { ...state, loadingZoneWarehouse: true }
        default:
            return state;
    }
};

export default ZoneReducer;

